import {
  FETCHED_PROJECTS,
  FETCHED_PROJECT,
  ENABLE_PROJECT_TIMELINE,
  PROJECT_DELETED,
  TAGS_ADDED_TO_PROJECT,
  PROJECT_REPORTS_COUNT_DECREMENT,
  PROJECT_SET_PAYMENT_REQUESTS_COUNT,
} from 'constants/actions';
import apiClient from 'helpers/api-client';

const PER_PAGE = 10;

function projectsFetched(projects) {
  return {
    type: FETCHED_PROJECTS,
    projects,
  };
}

function projectFetched(project) {
  return {
    type: FETCHED_PROJECT,
    project,
  };
}

function enabledProjectTimeline(projectId, enabled) {
  return {
    type: ENABLE_PROJECT_TIMELINE,
    projectId,
    enabled,
  };
}

function projectDeleted(projectId) {
  return {
    type: PROJECT_DELETED,
    projectId,
  };
}

function tagsAddedToProject(tagIds, projectId) {
  return {
    type: TAGS_ADDED_TO_PROJECT,
    tagIds,
    projectId,
  };
}

function decrementProjectReportsCount(projectId) {
  return {
    type: PROJECT_REPORTS_COUNT_DECREMENT,
    projectId,
  };
}

function addTagsToProject(projectId, tags) {
  return (dispatch) => {
    const tagIds = tags.map((t) => t.id);
    return apiClient
      .post(`locations/${projectId}/tags`, {
        tag_ids: tagIds,
      })
      .then(() => {
        dispatch(tagsAddedToProject(tagIds, projectId));
      });
  };
}

function fetchRecentProjects(companyId, page = 1, filters = {}) {
  return (dispatch) => {
    const tag_ids = filters.tag_ids ? filters.tag_ids : null;
    const start_date = filters.start_date ? filters.start_date : null;
    const end_date = filters.end_date ? filters.end_date : null;
    const path = `companies/${companyId}/locations/recent`;
    return apiClient
      .get(path, {
        page,
        per_page: PER_PAGE,
        tag_ids,
        start_date,
        end_date,
      })
      .then((projects) => {
        dispatch(projectsFetched(projects));
        return projects;
      });
  };
}

function fetchProject(projectId) {
  return (dispatch, getState) => {
    const state = getState();

    const project = state.projects.projectsById[projectId];
    if (project) {
      return Promise.resolve(project);
    }

    return apiClient.get(`locations/${projectId}`).then((location) => {
      dispatch(projectFetched(location));
      return location;
    });
  };
}

function updateProject(projectId, project) {
  return (dispatch) => {
    return apiClient
      .put(`locations/${projectId}`, { location: project })
      .then((updatedProject) => {
        dispatch(projectFetched(updatedProject));
        return updateProject;
      });
  };
}

function deleteProject(projectId) {
  return (dispatch) => {
    return apiClient.delete(`/locations/${projectId}`).then(() => {
      dispatch(projectDeleted(projectId));
      return projectId;
    });
  };
}

function createProject(project, project_template_id) {
  return (dispatch, getState) => {
    const state = getState();
    const companyId = state.user.company_id;

    const param = {
      location: project,
      project_template_id,
    };

    return apiClient
      .post(`companies/${companyId}/locations`, param)
      .then((createdProject) => {
        dispatch(projectFetched(createdProject));
        return createdProject;
      });
  };
}

function fetchUserRecentProjects(companyId, userId, page = 1, filters = null) {
  return (dispatch) => {
    const path = `companies/${companyId}/locations/user_recent`;
    const tag_ids = filters.tag_ids ? filters.tag_ids : null;
    const start_date = filters.start_date ? filters.start_date : null;
    const end_date = filters.end_date ? filters.end_date : null;
    return apiClient
      .get(path, {
        page,
        user_id: userId,
        per_page: PER_PAGE,
        tag_ids,
        start_date,
        end_date,
      })
      .then((projects) => {
        dispatch(projectsFetched(projects));
        return projects;
      });
  };
}

function setProjectTimelineEnabled(projectId, enabled) {
  return (dispatch, getState) => {
    const state = getState();

    const project = state.projects.projectsById[projectId];
    dispatch(enabledProjectTimeline(projectId, enabled));

    const path = `locations/${projectId}`;
    return apiClient
      .put(path, { location: { ...project, public: enabled } })
      .then((createdProject) => {
        dispatch(projectFetched(createdProject));
        return createdProject;
      })
      .catch(({ messages }) => {
        dispatch(enabledProjectTimeline(projectId, project.public));
        return messages;
      });
  };
}

function updateCoverPhoto(projectId, photoId) {
  return (dispatch) => {
    const path = `locations/${projectId}/featured_photo`;
    return apiClient.post(path, { image_id: photoId }).then((project) => {
      dispatch(projectFetched(project));
    });
  };
}

function mergeProjects(sourceprojectId, targetprojectId) {
  return (dispatch) => {
    const path = `locations/${sourceprojectId}/merge_projects`;
    return apiClient
      .post(path, { project: { target_project_id: targetprojectId } })
      .then((project) => {
        dispatch(projectFetched(project));
        dispatch(projectDeleted(sourceprojectId));
      });
  };
}

function setPaymentRequestsCount(projectId, paymentsCount) {
  return {
    type: PROJECT_SET_PAYMENT_REQUESTS_COUNT,
    projectId,
    paymentsCount,
  };
}

export {
  fetchRecentProjects,
  fetchUserRecentProjects,
  decrementProjectReportsCount,
  setProjectTimelineEnabled,
  createProject,
  updateProject,
  deleteProject,
  fetchProject,
  updateCoverPhoto,
  mergeProjects,
  addTagsToProject,
  setPaymentRequestsCount,
};
